<bfm-financial-record-details
  [financialRecordPk]="modalRef.data.financialRecordPk"
  [showAuthorizationSection]="modalRef.data.showAuthorizationSection"
  [chargeType]="modalRef.data.chargeType"
  [style.display]="selectedAmountGroup() ? 'none' : 'block'"
  (selectAmountGroup)="onSelectAmountGroup($event)"
/>

